import { useQuery } from '@tanstack/react-query';

import { EnvironmentId } from '@/react/portainer/environments/types';
import { getAMTInfo } from '@/portainer/hostmanagement/open-amt/open-amt.service';
import { withGlobalError } from '@/react-tools/react-query';

import { AMTInfo } from '../types';

export function useAMTInfo(
  environmentId: EnvironmentId,
  { enabled }: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: ['environments', environmentId, 'amt-info'],
    queryFn: async (): Promise<AMTInfo> => {
      const amtInfo = await getAMTInfo(environmentId);

      // Parse RawOutput if available
      if (amtInfo.rawOutput) {
        try {
          const parsedData = JSON.parse(amtInfo.rawOutput);
          return {
            amt: parsedData.AMT,
            uuid: parsedData.UUID,
            buildNumber: parsedData['Build Number'],
            controlMode: parsedData['Control Mode'],
            dnsSuffix: parsedData['DNS Suffix'],
          };
        } catch {
          return getErrorAMTInfo(amtInfo.rawOutput);
        }
      }

      return getEmptyAMTInfo();
    },
    enabled,
    ...withGlobalError('Unable to retrieve AMT environment details'),
  });
}

function getEmptyAMTInfo(): AMTInfo {
  return {
    amt: 'Loading...',
    uuid: '-',
    buildNumber: '-',
    controlMode: '-',
    dnsSuffix: '-',
  };
}

function getErrorAMTInfo(errorMessage: string): AMTInfo {
  return {
    amt: errorMessage,
    uuid: '-',
    buildNumber: '-',
    controlMode: '-',
    dnsSuffix: '-',
  };
}
